/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodResultContract} from '../../../api/contracts/period/period-result.contract';
import {PeriodResultModel} from './period-result.model';
import {PeriodDetailMapper} from '../period-detail/period-detail.mapper';

export class PeriodResultMapper {
    static fromPeriodResultContract(input: PeriodResultContract, timezone?: string): PeriodResultModel {
        let model: PeriodResultModel;

        if (input != null) {
            model = {
                totalResults: input?.totalResults,
                periodsPage: PeriodDetailMapper.fromPeriodDetailContractArray(input?.periodsPage, timezone)
            };
        }
        return model;
    }
}
